import {useEffect, useState} from "react";
import {useNavigate, useOutletContext} from "react-router-dom";
import {useEntityPermissions} from "snimf/permissions/hooks";
import {PlantationService} from "plantation/service";

import {EntityViewSubPage} from "base/entity/components/container";
import {EntityAuditSection} from "base/entity/components/presentational/sections";
import {ViewOrUpdatePlantationContent} from ".";
import {
    DeleteEntityButton,
    DeleteEntityDialog,
    DeleteItemDialog,
} from "base/delete/components";
import Alert from "@mui/material/Alert";

const ViewPlantationSummarySubPage = () => {
    const context = useOutletContext();
    const plantation = context[0];
    const navigate = useNavigate();

    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [deletionError, setDeletionError] = useState(null);
    const [canBeDeletedMsg, setCanBeDeletedMsg] = useState("");

    const {allowEdit, allowDelete} = useEntityPermissions(plantation, "plantations");

    useEffect(() => {
        setDeletionError(null);
    }, []);

    const handleCanBeDeleted = () => {
        PlantationService.canBeDeleted(plantation.id)
            .then(result => {
                if (result[0]) {
                    handleDelete();
                } else {
                    setCanBeDeletedMsg(result[1]);
                }
            })
            .catch(error => {
                setCanBeDeletedMsg(error);
                setDeletionError(error);
            });
    };
    const handleDelete = () => {
        PlantationService.delete(plantation.id)
            .then(() => {
                navigate("/plantations/all/list");
            })
            .catch(error => {
                setCanBeDeletedMsg(error);
                setDeletionError(error);
            });
    };

    const sectionsDetails = [
        {name: "generaldata", label: "Informações gerais"},
        {name: "comments", label: "Observações"},
    ];

    //TO-DO: Handle warnings
    const getDistrictWarning = () => {
        if (plantation?.plot && plantation?.plot?.district !== plantation?.district)
            return "O distrito da plantação não é o mesmo que o distrito de parcela.";
        return "";
    };

    const warningMessage = getDistrictWarning();

    const sections = [
        ...(warningMessage
            ? [
                  <Alert key="alert" severity="warning">
                      {warningMessage}
                  </Alert>,
              ]
            : []),
        ...sectionsDetails.map(section => (
            <ViewOrUpdatePlantationContent
                key={section.name}
                section={section.name}
                label={section.label}
                plantation={plantation}
                allowEdit={allowEdit}
            />
        )),
        <EntityAuditSection entity={plantation} key="audit" />,
    ];

    return (
        plantation && (
            <EntityViewSubPage sections={sections}>
                {allowDelete ? (
                    <>
                        <DeleteEntityButton
                            openDialog={() => setIsDeleteDialogOpen(true)}
                            entityName={"plantio"}
                        />
                        <DeleteItemDialog
                            isDialogOpen={isDeleteDialogOpen}
                            setIsDialogOpen={setIsDeleteDialogOpen}
                            deletionError={""}
                            onDelete={handleCanBeDeleted}
                        />
                        <DeleteEntityDialog
                            msg={canBeDeletedMsg}
                            setMsg={setCanBeDeletedMsg}
                            deletionError={deletionError}
                            onDelete={handleDelete}
                        />
                    </>
                ) : null}
            </EntityViewSubPage>
        )
    );
};

export default ViewPlantationSummarySubPage;
